export enum BuyingWish {
  toQualify = 'A qualifier',
  interestedIn = 'Interessé',
  reflexion = 'En reflexion',
  refusal = 'Refus'
}
